module.exports = __webpack_public_path__ + "img/personalize.3d3ccdac.svg";